function getToken() {
  let str = sessionStorage.getItem("USER_LOGIN");
  if (!str) {
    return null;
  }
  return JSON.parse(str).token;
}

const map = new Map([
  ["/", ""],
  ["/home", "用户"],
]);

export { getToken, map };
